import {AppServices} from "../../config/entities";
import {IUserSettingsDto} from "../../dtos/identity/IUserSettingsDto";
import {ICreateUserSettingsDto} from "../../dtos/identity/ICreateUserSettingsDto";
import {IUserSettingsService} from "./IUserSettingsService";

export class UserSettingsService implements IUserSettingsService {
    async getUserSettings(): Promise<IUserSettingsDto> {
        const response = await AppServices.Axios.get('/UserSettings');
        if (response.status === 200)
            return response.data;
        else
            throw new Error(response.statusText);
    }

    async setUserSettings(request: ICreateUserSettingsDto): Promise<void> {
        const response = await AppServices.Axios.put('/UserSettings', request);
        if (response.status === 200)
            return;
        else
            throw new Error(response.statusText);
    }
}